module.exports = __webpack_public_path__ + "img/horizontal_4_3_8017.a579c4e6.png";